import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";

/* ═══════════════════════════════════════════
   MENÚ REAL — La Sushitería Osorno
═══════════════════════════════════════════ */
const CATEGORIAS = [
  { id: "todos",      label: "Todo el menú",   emoji: "🍽️", nota: null },
  { id: "handrolls",  label: "Hand Rolls",     emoji: "🌮", nota: "Arma tu roll con 1 ingrediente de cada ítem · Incluye 1 salsa (Soya o Agridulce)" },
  { id: "hosomaki",   label: "Hosomaki",       emoji: "🍣", nota: "Rolls en base de arroz cubiertos por Alga Nori, rellenos con Queso Crema e ingredientes a elección · Cortado en 10 bocados" },
  { id: "rolls",      label: "Rolls",          emoji: "🍱", nota: "10 bocados · Elige tu envoltorio: Queso Crema, Palta, Sésamo, Salmón, Merkén, Almendras o Panko" },
  { id: "gourmet",    label: "Rolls Gourmet",  emoji: "⭐", nota: "10 bocados con ingredientes premium y envolturas especiales · Desde $7.000" },
  { id: "meats",      label: "Meats Rolls",    emoji: "🥩", nota: "10 bocados de carne de vacuno · Elige tu envoltorio: Queso Crema, Palta o Panko" },
  { id: "sinarroz",   label: "Sin Arroz",      emoji: "🥬", nota: "8 bocados · Envoltorio a elegir: Queso Crema, Palta o Panko · Sin cambio de ingredientes" },
  { id: "burger",     label: "Sushi Burger",   emoji: "🍔", nota: "600 grs de sabor · Incluye 2 salsas (Soya/Agridulce) · Sin cambio de ingredientes" },
  { id: "picadillos", label: "Picadillos",     emoji: "🍗", nota: "Porciones individuales o para compartir" },
  { id: "gohan",      label: "Gohan",          emoji: "🥣", nota: "Base de arroz con Queso Crema, Palta, Cebollín y Sésamo · Incluye 2 salsas (Soya/Agridulce)" },
  { id: "platos",     label: "Platos",         emoji: "🍛", nota: "Platos principales de fusión" },
];

const MENU = [
  /* ── Hand Rolls ── */
  { id: 1,  cat: "handrolls", emoji: "🍗", nombre: "Hand Roll ", descripcion: "Pollo Katzu, Pollo Teriyaki o Kanikama · con/sin queso crema · Palta o Cebollín.", precio: 4000 },
  { id: 2,  cat: "handrolls", emoji: "🦐", nombre: "Hand Roll ", descripcion: "Salmón o Camarón · con/sin queso crema · Palta o Cebollín.",                       precio: 4500 },

  /* ── Hosomaki (10 bocados) ── */
  { id: 3,  cat: "hosomaki", emoji: "🐟", nombre: "Hosomaki Salmón",     descripcion: "Roll clásico cubierto en Alga Nori, relleno de Salmón y Queso Crema.",     precio: 4500 },
  { id: 4,  cat: "hosomaki", emoji: "🦐", nombre: "Hosomaki Camarón",    descripcion: "Roll clásico cubierto en Alga Nori, relleno de Camarón y Queso Crema.",    precio: 4500 },
  { id: 5,  cat: "hosomaki", emoji: "🍗", nombre: "Hosomaki Pollo Katzu",descripcion: "Roll clásico cubierto en Alga Nori, relleno de Pollo Katzu y Queso Crema.",precio: 4000 },
  { id: 6,  cat: "hosomaki", emoji: "🦀", nombre: "Hosomaki Kanikama",   descripcion: "Roll clásico cubierto en Alga Nori, relleno de Kanikama y Queso Crema.",   precio: 4000 },

  /* ── Rolls $6.500 (10 bocados) ── */
  { id: 7,  cat: "rolls", emoji: "🍗", nombre: "Temu",           descripcion: "Pollo Teriyaki, Queso Crema y Cebollín.",                precio: 6500 },
  { id: 8,  cat: "rolls", emoji: "🍄", nombre: "Vegel",          descripcion: "Champiñón, Queso Crema y Palmito.",                       precio: 6500 },
  { id: 9,  cat: "rolls", emoji: "🦀", nombre: "Maki",           descripcion: "Kanikama, Queso Crema y Palta.",                          precio: 6500 },
  { id: 10, cat: "rolls", emoji: "🍗", nombre: "Katzu",          descripcion: "Pollo Apanado, Queso Crema y Cebollín.",                  precio: 6500 },
  { id: 11, cat: "rolls", emoji: "🍄", nombre: "Katzu Especial", descripcion: "Pollo Apanado, Queso Crema y Champiñón.",                 precio: 6500 },
  { id: 12, cat: "rolls", emoji: "🥑", nombre: "Katzu Avocado",  descripcion: "Pollo Apanado, Queso Crema y Palta.",                     precio: 6500 },
  { id: 13, cat: "rolls", emoji: "🦐", nombre: "Ebi Teri",       descripcion: "Camarón, Queso Crema y Pollo Teriyaki.",                  precio: 6500 },
  { id: 14, cat: "rolls", emoji: "🦐", nombre: "Ebi Cheese",     descripcion: "Camarón, Queso Crema y Palta.",                           precio: 6500 },
  { id: 15, cat: "rolls", emoji: "🦐", nombre: "Tori",           descripcion: "Camarón, Queso Crema y Cebollín.",                        precio: 6500 },
  { id: 16, cat: "rolls", emoji: "🐟", nombre: "California",     descripcion: "Salmón, Queso Crema y Cebollín.",                         precio: 6500 },
  { id: 17, cat: "rolls", emoji: "🥑", nombre: "Avocado Cheese", descripcion: "Salmón, Queso Crema y Palta.",                            precio: 6500 },
  { id: 18, cat: "rolls", emoji: "🥑", nombre: "Temu Avocado",   descripcion: "Pollo Teriyaki, Queso Crema y Palta.",                    precio: 6500 },
  { id: 19, cat: "rolls", emoji: "🦐", nombre: "Emi Cheese",     descripcion: "Pollo Apanado, Queso Crema y Camarón.",                   precio: 6500 },

  /* ── Rolls Gourmet $7.000 ── */
  { id: 20, cat: "gourmet", emoji: "🦐", nombre: "Ebi Furay",      descripcion: "Camarón Tempura, Queso Crema y Palta. Envuelto en Palta o Panko.",                                          precio: 7000 },
  { id: 21, cat: "gourmet", emoji: "🍗", nombre: "Teri Rolls",     descripcion: "Pollo Teriyaki, Queso Crema y Almendras. Envuelto en Queso y Almendras.",                                   precio: 7000 },
  { id: 22, cat: "gourmet", emoji: "🌶️", nombre: "Ebi Hot",        descripcion: "Camarón, Salsa Spicy, Queso Crema y Cebollín. Envuelto en Queso Crema o Salmón.",                          precio: 7000 },
  { id: 23, cat: "gourmet", emoji: "🦐", nombre: "Crispy Teri",    descripcion: "Camarón, Queso Crema y Cebollín. Envuelto en Panko, cubierto en Pollo Teriyaki y Sésamo.",                 precio: 7000 },
  { id: 24, cat: "gourmet", emoji: "🍄", nombre: "Tem Rolls",      descripcion: "Camarón, Queso Crema y Champiñón. Envuelto en Salmón.",                                                    precio: 7000 },
  { id: 25, cat: "gourmet", emoji: "🐟", nombre: "Cheese Tem",     descripcion: "Salmón Tempura, Palta y Cebollín. Envuelto en Queso Crema y Almendras.",                                   precio: 7000 },
  { id: 26, cat: "gourmet", emoji: "🦐", nombre: "Tempura Rolls",  descripcion: "Camarón Tempura, Queso Crema y Cebollín. Envuelto en Palta.",                                              precio: 7000 },
  { id: 27, cat: "gourmet", emoji: "🐟", nombre: "Sake Tempura",   descripcion: "Salmón Tempura, Queso Crema, Cebollín y Spicy. Envuelto en Palta.",                                        precio: 7000 },
  { id: 28, cat: "gourmet", emoji: "🌶️", nombre: "Spicy Tempura",  descripcion: "Salmón, Queso Crema, Spicy y Crispy. Envuelto en Nori Panko.",                                             precio: 7000 },
  /* ── Rolls Gourmet $7.500 ── */
  { id: 29, cat: "gourmet", emoji: "🥑", nombre: "Avocado Spicy",  descripcion: "Salmón, Palta, Queso Crema, Cebollín y Spicy. Envuelto en Nori Panko.",                                   precio: 7500 },
  { id: 30, cat: "gourmet", emoji: "🐙", nombre: "Tako Chives",    descripcion: "Pulpo, Queso Crema y Cebollín. Envuelto en Palta.",                                                        precio: 7500 },
  { id: 31, cat: "gourmet", emoji: "🐙", nombre: "Tako Spicy",     descripcion: "Pulpo, Queso Crema, Cebollín y Spicy. Envuelto en Palta o Panko.",                                        precio: 7500 },
  { id: 32, cat: "gourmet", emoji: "🦐", nombre: "Ebi Chives",     descripcion: "Camarón, Queso Crema y Cebollín. Envuelto en Salmón Apanado.",                                            precio: 7500 },
  { id: 33, cat: "gourmet", emoji: "🐟", nombre: "Sake Especial",  descripcion: "Salmón, Queso Crema y Camarón. Envuelto en Palta o Panko.",                                               precio: 7500 },
  { id: 34, cat: "gourmet", emoji: "🦐", nombre: "Ebi Top",        descripcion: "Camarón, Queso Crema y Palta. Con trozos de Salmón montado y Salsa Dragón.",                              precio: 7500 },
  { id: 35, cat: "gourmet", emoji: "🐟", nombre: "Hilo Rolls",     descripcion: "Camarón Tempura, Queso Crema y Palta. Envuelto en Salmón con Salsa Acevichada y Crocante de Kanikama.",   precio: 7500 },
  { id: 36, cat: "gourmet", emoji: "🫧",  nombre: "Acevichado Tem", descripcion: "Camarón Tempura, Queso Crema y Palta. Envuelto en Salmón, bañado en Salsa Acevichada y Camarones.",       precio: 7500 },

  /* ── Meats Rolls (10 bocados) ── */
  { id: 37, cat: "meats", emoji: "🥑", nombre: "Avocado Meats", descripcion: "Carne de Vacuno, Queso Crema y Palta.",                                          precio: 7000 },
  { id: 38, cat: "meats", emoji: "🥩", nombre: "Chives Meats",  descripcion: "Carne de Vacuno, Queso Crema y Cebollín.",                                       precio: 7000 },
  { id: 39, cat: "meats", emoji: "🥓", nombre: "Meats Premium", descripcion: "Carne de Vacuno, Queso Crema y Cebollín. Envuelto en Panceta Panko.",            precio: 7500 },

  /* ── Rolls sin Arroz $8.000 (8 bocados) ── */
  { id: 40, cat: "sinarroz", emoji: "🐟", nombre: "Ebi Sake Cheese",      descripcion: "Salmón, Camarón, Queso Crema y Palta.",                               precio: 8000 },
  { id: 41, cat: "sinarroz", emoji: "🥑", nombre: "Katzu Avocado Cheese", descripcion: "Pollo Apanado, Queso Crema, Palta y Champiñón.",                     precio: 8000 },
  { id: 42, cat: "sinarroz", emoji: "🦐", nombre: "Ebi Teri Cheese",      descripcion: "Pollo Teriyaki, Camarón, Queso Crema, Palta y Cebollín.",            precio: 8000 },
  { id: 43, cat: "sinarroz", emoji: "🌿", nombre: "Natural Cheese",       descripcion: "Palta, Queso Crema, Champiñón, Palmito y Cebollín.",                 precio: 8000 },

  /* ── Sushi Burger ── */
  { id: 44, cat: "burger", emoji: "🐟", nombre: "Fish Burger",  descripcion: "Salmón, Camarón, Palta, Cebollín y Queso Crema. 600 grs de sabor.",                          precio: 9800 },
  { id: 45, cat: "burger", emoji: "🥩", nombre: "Carne Burger", descripcion: "Carne de Vacuno, Pollo Apanado, Palta, Cebollín y Queso Crema. 600 grs de sabor.",           precio: 9500 },
  { id: 46, cat: "burger", emoji: "🥑", nombre: "Huerto Burger",descripcion: "Cebollín, Palta, Palmito, Champiñón y Queso Crema. 600 grs de sabor vegetariano.",           precio: 9500 },

  /* ── Picadillos ── */
  { id: 47, cat: "picadillos", emoji: "🍗", nombre: "Pollo Katzu",  descripcion: "10 filetitos de pechuga de pollo apanados en Panko. Incluye 1 salsa.",                    precio: 6500 },
  { id: 48, cat: "picadillos", emoji: "🍄", nombre: "Kinoko",       descripcion: "4 bocados rellenos de Champiñón, Queso Crema, Cebollín y Pollo Katzu en Nori Panko. Incluye 1 salsa.", precio: 6500 },
  { id: 49, cat: "picadillos", emoji: "🐟", nombre: "Sakanatataki", descripcion: "150 grs de cubos de salmón marinados en aceite de sésamo.",                               precio: 7000 },

  /* ── Gohan ── */
  { id: 50, cat: "gohan", emoji: "🍗", nombre: "Gohan Pollo Katzu",      descripcion: "Base de arroz con Queso Crema, Palta, Cebollín y Sésamo · Pollo Katzu.",       precio: 7500 },
  { id: 51, cat: "gohan", emoji: "🦐", nombre: "Gohan Camarón y Salmón", descripcion: "Base de arroz con Queso Crema, Palta, Cebollín y Sésamo · Camarón y Salmón.", precio: 8500 },

  /* ── Platos ── */
  { id: 52, cat: "platos", emoji: "🍳", nombre: "Chaufa Mixto",  descripcion: "Arroz salteado con verduras, salmón, camarón y pollo con aceite de sésamo.",                            precio: 9000 },
  { id: 53, cat: "platos", emoji: "🍋", nombre: "Ceviche Mixto", descripcion: "500 grs de ceviche de salmón y camarón con verduras frescas y condimentos especiales. ⚡ Stock limitado.", precio: 9990 },
];

const PROMOS = [
  {
    emoji: "🎉",
    titulo: "Mix 50",
    descripcion: "Temu (panko) · Vegel (panko) · Maki (sésamo) · Katzu (palta) · Hosomaki Kanikama · Incluye 3 palitos y 5 salsas",
    precio: "$21.500",
    badge: "50 bocados",
  },
  {
    emoji: "🥢",
    titulo: "40 Seleccionados",
    descripcion: "Katzu (panko) · California (panko) · Ebi Cheese (palta) · Katzu Especial (queso crema y sésamo) · Incluye 2 palitos y 4 salsas",
    precio: "$21.500",
    badge: "40 bocados",
  },
  {
    emoji: "🌟",
    titulo: "Sugerencia 2 · 40 bocados",
    descripcion: "Avocado Cheese (palta + salsa acevichada) · Ebi Cheese (panko) · Temu (panko) · Hosomaki Kanikama · Incluye 2 palitos y 4 salsas",
    precio: "$21.500",
    badge: "40 bocados",
  },
  {
    emoji: "🎊",
    titulo: "Sugerencia 3 · 50 bocados",
    descripcion: "Avocado Cheese (palta) · Ebi Cheese (salmón) · Katzu (sésamo) · Temu (panko) · Hosomaki Camarón · Incluye 4 palitos y 5 salsas · Puedes solicitar wasabi o jengibre",
    precio: "$26.500",
    badge: "50 bocados",
  },
  {
    emoji: "🏆",
    titulo: "Sugerencia 4 · 70 bocados",
    descripcion: "Avocado Cheese · Ebi Cheese · Katzu Avocado · Temu · Katzu · Hosomaki Camarón · Hosomaki Salmón · Incluye 4 palitos y 7 salsas · Puedes solicitar wasabi o jengibre",
    precio: "$33.500",
    badge: "70 bocados",
  },
];

const GALERIA = [
  { bg: "linear-gradient(135deg,#2d0a0a 0%,#6b1a1a 100%)", emoji: "🍱", label: "Sushi platter" },
  { bg: "linear-gradient(135deg,#0d1a0d 0%,#1a4a1a 100%)", emoji: "🍣", label: "Rolls variados" },
  { bg: "linear-gradient(135deg,#0a1020 0%,#1a2a50 100%)", emoji: "🐟", label: "Salmón fresco" },
  { bg: "linear-gradient(135deg,#1a0d00 0%,#4a2a00 100%)", emoji: "🌶️", label: "Spicy collection" },
  { bg: "linear-gradient(135deg,#1a0a2d 0%,#3a1a5a 100%)", emoji: "🥑", label: "Avocado rolls" },
  { bg: "linear-gradient(135deg,#111 0%,#333 100%)",        emoji: "🌮", label: "Hand rolls" },
];

const fmtCLP = (n) =>
  new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", maximumFractionDigits: 0 }).format(n);

/* ═══════════════════════════════════════════
   Secciones
═══════════════════════════════════════════ */
function Hero({ menuRef, navigate }) {
  return (
    <section className="h-hero">
      <div className="h-hero__bg" aria-hidden />
      <div className="h-hero__content">
        <img src="/logolasushiteria.png" alt="La Sushitería" className="h-hero__logo" />
        <p className="h-hero__eyebrow">La Sushitería Osorno</p>
        <h1 className="h-hero__title">
          Sushi fresco,<br />rápido y delicioso
        </h1>
        <p className="h-hero__sub">
          Ingredientes frescos, preparación artesanal y sabor que te hace volver.
          <br />Directo a tu mesa en Osorno.
        </p>
        <div className="h-hero__actions">
          <button
            className="h-btn h-btn--primary"
            onClick={() => menuRef.current?.scrollIntoView({ behavior: "smooth" })}
          >
            Ver menú
          </button>
          <button className="h-btn h-btn--ghost" onClick={() => navigate("/login")}>
            Acceso trabajadores
          </button>
        </div>
      </div>
      <div className="h-hero__scroll-hint" aria-hidden>↓</div>
    </section>
  );
}

function MenuSection({ innerRef }) {
  const [catActiva, setCatActiva] = useState("todos");

  const catInfo = CATEGORIAS.find((c) => c.id === catActiva);

  /* Items a mostrar + agrupación para "todos" */
  const itemsFiltrados = catActiva === "todos"
    ? MENU
    : MENU.filter((item) => item.cat === catActiva);

  /* Para "todos": agrupar por categoría con encabezados */
  const grupos = catActiva === "todos"
    ? CATEGORIAS.filter((c) => c.id !== "todos").map((c) => ({
        cat: c,
        items: MENU.filter((item) => item.cat === c.id),
      })).filter((g) => g.items.length > 0)
    : null;

  return (
    <section className="h-section" ref={innerRef} id="menu">
      <div className="h-container">
        <div className="h-section__head">
          <span className="h-label">Nuestro menú</span>
          <h2 className="h-section__title">¿Qué se te antoja hoy?</h2>
          <p className="h-section__desc">Todo preparado al momento con ingredientes frescos del día.</p>
        </div>

        {/* Tabs de categoría */}
        <div className="h-menu-tabs" role="tablist">
          {CATEGORIAS.map((c) => (
            <button
              key={c.id}
              role="tab"
              aria-selected={catActiva === c.id}
              className={`h-menu-tab ${catActiva === c.id ? "active" : ""}`}
              onClick={() => setCatActiva(c.id)}
            >
              <span className="h-menu-tab__emoji">{c.emoji}</span>
              <span>{c.label}</span>
            </button>
          ))}
        </div>

        {/* Nota de categoría */}
        {catActiva !== "todos" && catInfo?.nota && (
          <div className="h-cat-note">
            <span className="h-cat-note__icon">ℹ️</span>
            {catInfo.nota}
          </div>
        )}

        {/* Grid de productos — vista plana (categoría específica) */}
        {catActiva !== "todos" && (
          <div className="h-menu-grid">
            {itemsFiltrados.map((item) => (
              <MenuCard key={item.id} item={item} />
            ))}
          </div>
        )}

        {/* Vista agrupada — todos */}
        {catActiva === "todos" && grupos && grupos.map(({ cat, items }) => (
          <div key={cat.id} className="h-menu-grupo">
            <div className="h-menu-grupo__head">
              <span className="h-menu-grupo__emoji">{cat.emoji}</span>
              <div>
                <h3 className="h-menu-grupo__titulo">{cat.label}</h3>
                {cat.nota && <p className="h-menu-grupo__nota">{cat.nota}</p>}
              </div>
            </div>
            <div className="h-menu-grid">
              {items.map((item) => (
                <MenuCard key={item.id} item={item} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function MenuCard({ item }) {
  return (
    <div className="h-menu-card">
      <div className="h-menu-card__icon">{item.emoji}</div>
      <div className="h-menu-card__body">
        <h3 className="h-menu-card__name">{item.nombre}</h3>
        <p className="h-menu-card__desc">{item.descripcion}</p>
        <span className="h-menu-card__price">{fmtCLP(item.precio)}</span>
      </div>
    </div>
  );
}

function PromoSection() {
  return (
    <section className="h-section h-section--dark" id="promos">
      <div className="h-container">
        <div className="h-section__head">
          <span className="h-label h-label--light">Promociones</span>
          <h2 className="h-section__title h-section__title--light">Combos que convienen</h2>
          <p className="h-section__desc h-section__desc--light">
            Perfectos para compartir · Puedes solicitar wasabi o jengibre
          </p>
        </div>
        <div className="h-promo-grid">
          {PROMOS.map((p, i) => (
            <div className={`h-promo-card ${i === 0 ? "h-promo-card--accent" : ""}`} key={p.titulo}>
              <span className="h-promo-badge">{p.badge}</span>
              <div className="h-promo-emoji">{p.emoji}</div>
              <h3 className="h-promo-title">{p.titulo}</h3>
              <p className="h-promo-desc">{p.descripcion}</p>
              <strong className="h-promo-price">{p.precio}</strong>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function GallerySection() {
  return (
    <section className="h-section h-section--light" id="galeria">
      <div className="h-container">
        <div className="h-section__head">
          <span className="h-label">Galería</span>
          <h2 className="h-section__title">Hecho con pasión</h2>
          <p className="h-section__desc">Cada plato es una obra de arte. Aquí van nuestras fotos.</p>
        </div>
        <div className="h-gallery">
          {GALERIA.map((img, i) => (
            <div
              key={i}
              className="h-gallery__item"
              style={{ background: img.bg }}
              role="img"
              aria-label={img.label}
            >
              <span className="h-gallery__emoji" aria-hidden>{img.emoji}</span>
              <span className="h-gallery__label">{img.label}</span>
            </div>
          ))}
        </div>
        <p className="h-gallery__note">📸 Próximamente nuestras fotos reales</p>
      </div>
    </section>
  );
}

function AboutSection() {
  return (
    <section className="h-section" id="nosotros">
      <div className="h-container">
        <div className="h-about">
          <div className="h-about__text">
            <span className="h-label">Sobre nosotros</span>
            <h2 className="h-section__title">Un pedacito de Japón<br />en Osorno</h2>
            <p>
              Somos un emprendimiento local con un solo objetivo: traerte el sushi más fresco y
              sabroso de la zona. Usamos ingredientes de primera calidad, arroz preparado cada día
              y pescado seleccionado de nuestros proveedores de confianza.
            </p>
            <p>
              Cada roll es armado al momento, con cariño y atención al detalle. Porque creemos
              que la buena comida también se siente.
            </p>
            <ul className="h-about__valores">
              <li>🌿 Ingredientes frescos</li>
              <li>🤝 Atención cercana</li>
              <li>⚡ Servicio rápido</li>
              <li>❤️ Sabor que vuelve</li>
            </ul>
          </div>
          <div className="h-about__visual">
            <div className="h-about__logo-wrap">
              <img src="/logolasushiteria.png" alt="La Sushitería" />
            </div>
            <div className="h-about__badge">Desde Osorno<br />para Osorno</div>
          </div>
        </div>
      </div>
    </section>
  );
}

function ContactSection() {
  return (
    <section className="h-section h-section--dark" id="contacto">
      <div className="h-container">
        <div className="h-section__head">
          <span className="h-label h-label--light">Contacto</span>
          <h2 className="h-section__title h-section__title--light">Encuéntranos</h2>
          <p className="h-section__desc h-section__desc--light">
            Pedidos y consultas por WhatsApp o síguenos en redes sociales.
          </p>
        </div>
        <div className="h-social">
          <a
            className="h-social__btn h-social__btn--wa"
            href="https://wa.me/56984469600"
            target="_blank"
            rel="noreferrer"
          >
            <span className="h-social__icon">💬</span>
            <span>WhatsApp</span>
          </a>
          <a
            className="h-social__btn h-social__btn--ig"
            href="https://www.instagram.com/la_sushiteria_kitchenfusion?igsh=MWk4c25yYmo2aHVxZA=="
            target="_blank"
            rel="noreferrer"
          >
            <span className="h-social__icon">📸</span>
            <span>Instagram</span>
          </a>
          <a
            className="h-social__btn h-social__btn--fb"
            href="https://www.facebook.com/share/18HyTL2CHn/?mibextid=wwXIfr"
            target="_blank"
            rel="noreferrer"
          >
            <span className="h-social__icon">👍</span>
            <span>Facebook</span>
          </a>
        </div>
        <p className="h-contact-address">📍 Osorno, Los Lagos, Chile</p>
      </div>
    </section>
  );
}

function HomeFooter({ navigate }) {
  return (
    <footer className="h-footer">
      <div className="h-container h-footer__inner">
        <div className="h-footer__brand">
          <img src="/logolasushiteria.png" alt="Logo" />
          <span>La Sushitería Osorno</span>
        </div>
        <p className="h-footer__copy">
          © {new Date().getFullYear()} La Sushitería. Todos los derechos reservados.
        </p>
        <div className="h-footer__links">
          <button type="button" className="h-footer__link" onClick={() => navigate("/login")}>
            Acceso trabajadores
          </button>
        </div>
      </div>
    </footer>
  );
}

/* ═══════════════════════════════════════════
   Componente principal
═══════════════════════════════════════════ */
export default function Home({ usuario }) {
  const navigate = useNavigate();
  const menuRef = useRef(null);

  useEffect(() => {
    if (usuario) navigate("/pos", { replace: true });
  }, [usuario, navigate]);

  if (usuario) return null;

  return (
    <div className="h-page">
      <Hero menuRef={menuRef} navigate={navigate} />
      <MenuSection innerRef={menuRef} />
      <PromoSection />
      <GallerySection />
      <AboutSection />
      <ContactSection />
      <HomeFooter navigate={navigate} />
    </div>
  );
}
